export default __webpack_public_path__ + "static/118-2740928f857bf32da642d5e8f2998f2a.jpg";